import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import compose from 'lodash/fp/compose';
import _ from 'lodash';
import { COMPANY_FORM, CLIENT_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, newCompany } from 'src/reducers/clients/clients';
import NewCompany from './components/NewCompany';
import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';

let NewCompanyForm = reduxForm({
  form: CLIENT_FORM
})(NewCompany);

// ownPropsにはviews/new.html.erbからの情報が入る
const mapStateToProps = state => ({
  isNewForm: true,
  initialValues: { client:{} , clientBranch:[]},
  errors: getItemErrors(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(newCompany(data))
});

NewCompanyForm = connect(mapStateToProps, mapDispatchToProps)(NewCompanyForm);

const CompanyForm = () => {
  return (
    <NewCompanyForm />
  );
};

export default connect()(CompanyForm);